import { calculateLineHeight } from '../utils/calculateLineHeight/index.js';
import { pxToRem } from '../../v2/foundation/spacing/utils.js';

var size = {
  tiny: pxToRem(11),
  small: pxToRem(13),
  base: pxToRem(15),
  infrequent: pxToRem(20),
  medium: pxToRem(24),
  large: pxToRem(28),
  xLarge: pxToRem(40)
};
var fontSize = function fontSize(sizeOrName, lineHeight) {
  if (lineHeight === void 0) {
    lineHeight = 'auto';
  }
  var value = (size === null || size === void 0 ? void 0 : size[sizeOrName]) || sizeOrName;
  return "\n    font-size: " + value + ";\n    line-height: " + (lineHeight === 'auto' ? calculateLineHeight(value) : lineHeight) + ";\n  ";
};

export { fontSize, size };
